/// <amd-module name="CodeCoverage/CodeCoverageCiChangedTab/Helpers" />
import { IFileCoverageTableItem } from "CodeCoverage/ViewCommon/Contracts/Common";
import { FileCoverageChange } from "CodeCoverage/Clients/Coverage/Contracts/Coverage";

export function mapChangedFilesToFileCoverageTableItem(files: FileCoverageChange[]): IFileCoverageTableItem[] {
    const filesCoverageTableItems: IFileCoverageTableItem[] = [];

    if (files && files.length > 0) {
        files.map(file => {
            const covered = file.summary.covered || 0;
            const notCovered = file.summary.notCovered || 0;
            const partiallyCovered = file.summary.partiallyCovered || 0;
            const coverageChange = file.change || 0;

            const totalLinesCount = covered + partiallyCovered + notCovered;
            const percentageCalculated = totalLinesCount != 0 ? (covered / totalLinesCount) * 100 : 0;

            filesCoverageTableItems.push({
                filePath: file.summary.path,
                coveragePercentage: percentageCalculated,
                coverageChangePercentage: coverageChange,
                totalLines: totalLinesCount,
                notCoveredLines: notCovered,
                coveredLines: covered,
                partiallyCoveredLines: partiallyCovered
            });
        });
    }

    return filesCoverageTableItems;
}
